import { createContext, useContext } from 'react';

interface FieldDisplayContextValue {
  hideLabel: boolean;
}

export const FieldDisplayContext = createContext<FieldDisplayContextValue>({
  hideLabel: false,
});

export const useFieldDisplay = () => useContext(FieldDisplayContext);
